<div class="thp-form-container">
  <div class="thp-message">
    <h1 class="thp-header">{{ contentText }}</h1>

    <p *ngIf="showSpinner">
      {{ "talent-happy-path.initial-interview-questions.splash-page.sub-heading-when-questions" | translate }}
    </p>

    <div class="spinner-container">
      <mat-spinner *ngIf="showSpinner" [diameter]="40"></mat-spinner>
    </div>
  </div>
  <div class="button-container">
    <button *ngIf="noQuestions" id="iiq-splash-page-next-button" mat-flat-button class="custom-button" (click)="navigateToTalentProfile()">
      {{ "talent-happy-path.buttons.next" | translate }}
    </button>
    <button *ngIf="showLaterButton" id="iiq-splash-page-do-later" (click)="clickIllDoThisLater()" mat-button class="later-button">
      {{ "talent-happy-path.buttons.do-later" | translate }}
    </button>
  </div>
</div>

